module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"adminUsersLink":"User Admin","adminPortfoliosLink":"Portfolio Admin","userManagement":"Benutzerverwaltung (Admin)","login":"Anmelden","logout":"Abmelden"}}')
  delete Component.options._Ctor
}
